import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { routeLinks } from '../data/navigation';
export function SiteFooter() {
  const year = new Date().getFullYear();
  return <footer className="bg-navy" data-id="element-189" data-mp="3mfyfeb7tphqi">
      <div className="mx-auto grid max-w-shell gap-12 px-6 py-16 lg:grid-cols-12 lg:px-8" data-id="element-190" data-mp="3hig2k9qoqid8">
        <div className="lg:col-span-5" data-id="element-191" data-mp="3hglrdn57u4mc">
          <p className="font-serif text-xl text-white" data-id="element-192" data-mp="3dh4kqqe1z1fl">GREGORY J. SLAVONIC</p>
          <p className="mt-1 text-[11px] font-semibold uppercase tracking-overline text-gold-light" data-id="element-193" data-mp="38i1dr0eiil4z">
            Rear Admiral, U.S. Navy (Ret.)
          </p>
          <ul className="mt-8 flex flex-col gap-4" data-id="element-194" data-mp="33ix8gkupl7jx">
            <li className="flex items-center gap-3 text-sm text-slate-300" data-id="element-195" data-mp="2yk3qaf4h8sdf">
              <MailIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-196" data-mp="11rbobx95bi9i" />
              <a href="mailto:office@bluewaterstrategies.com" className="underline-offset-4 hover:text-white hover:underline" data-id="element-197" data-mp="11p7lzjqwarbc">
                office@bluewaterstrategies.com
              </a>
            </li>
            <li className="flex items-center gap-3 text-sm text-slate-300" data-id="element-198" data-mp="1aqzput9z1k70">
              <PhoneIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-199" data-mp="vt7dg9zq1bx1" />
              <a href="tel:+14055550142" className="underline-offset-4 hover:text-white hover:underline" data-id="element-200" data-mp="10rsg0g2g47on">
                (405) 555-0142
              </a>
            </li>
            <li className="flex items-center gap-3 text-sm text-slate-300" data-id="element-201" data-mp="1oi4t05cjsum3">
              <MapPinIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-202" data-mp="1tf4qvsz8ur24" />
              Oklahoma City, Oklahoma &middot; Washington, D.C.
            </li>
          </ul>
        </div>

        <nav aria-label="Footer" className="lg:col-span-4" data-id="element-203" data-mp="1jpl80nbj6x79">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-slate-500" data-id="element-204" data-mp="27g7b006ohrae">
            Sections
          </p>
          <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3" data-id="element-205" data-mp="2c77drm2hb3kt">
            {routeLinks.map(link => <li key={link.to} data-id="element-206" data-mp="2m1uwppsj53vd">
                <Link to={link.to} className="text-sm text-slate-300 underline-offset-4 hover:text-gold-light hover:underline" data-id="element-207" data-mp="2m0tmton92nf8">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="lg:col-span-3" data-id="element-208" data-mp="282v7oh13umyo">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-slate-500" data-id="element-209" data-mp="234leud2uryg8">
            Representation
          </p>
          <p className="mt-5 text-sm leading-relaxed text-slate-300" data-id="element-210" data-mp="1ycjxwduqpjjv">
            Speaking engagements represented by Worldwide Speakers Group. Advisory and
            board inquiries handled by Blue-Water Strategies, LLC.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-211" data-mp="1ke3q0jl55n05">
        <div className="mx-auto flex max-w-shell flex-col gap-4 px-6 py-8 lg:flex-row lg:items-start lg:justify-between lg:px-8" data-id="element-212" data-mp="1kcslghjvgb7z">
          <p className="max-w-3xl text-xs leading-relaxed text-slate-500" data-id="element-213" data-mp="3r1t75ai5w0sr">
            Disclaimer: References to military service and federal appointments are
            provided for biographical purposes only and do not imply endorsement by the
            Department of the Navy, the Department of Defense, or any agency of the
            United States Government or the State of Oklahoma.
          </p>
          <p className="whitespace-nowrap text-xs text-slate-500" data-id="element-214" data-mp="38blbfdgskcml">
            &copy; {year} Blue-Water Strategies, LLC
          </p>
        </div>
      </div>
    </footer>;
}